export default "__VITE_ASSET__DGiFZKf8__"